import { render, staticRenderFns } from "./RejectionActionCard.vue?vue&type=template&id=04a94392&"
import script from "./RejectionActionCard.vue?vue&type=script&lang=js&"
export * from "./RejectionActionCard.vue?vue&type=script&lang=js&"
import style0 from "./RejectionActionCard.vue?vue&type=style&index=0&id=04a94392&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports